// const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_BASE_URL = window.__CONFIG__?.API_BASE_URL || "";

export const CLIENTS_API_URL = `${API_BASE_URL}/api/clients`;
export const ORDERS_API_URL = `${API_BASE_URL}/api/orders`;
export const BILLS_API_URL = `${API_BASE_URL}/api/bills`;
export const AUTH_API_URL = `${API_BASE_URL}/api/auth`;
export const TEST_API_URL = `${API_BASE_URL}/test`;
export const DASHBOARD_COUNTS_URL = `${API_BASE_URL}/api/order-counts`;
export const NOTES_URL = `${API_BASE_URL}/api/notes`;